// fast-color-loading pdp color siblings prefetch
// prefetch sibling product pages for color swatches to make color changes faster on product pages.

// Prefetch siblings for all color swatches on this product page. Do not remove.
/*
window.addEventListener('load', function () {
  if (!document.body.classList.contains('template-product')) return;

  const swatches = document.querySelectorAll('.color-radio-buttons a[href]');
  const head = document.head;
  const added = new Set();

  const currentPath = window.location.pathname.replace(/\/$/, '');

  swatches.forEach(function (swatch) {
    let url = swatch.getAttribute('href');
    if (!url) return;

    if (!url.startsWith('http')) {
      url = new URL(url, window.location.origin).href;
    }

    const path = new URL(url).pathname.replace(/\/$/, '');

    if (path === currentPath || added.has(path)) return;
    added.add(path);

    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = url;
    head.appendChild(link);
  });
});
*/

// fast-color-loading pdp color siblings prefetch
// prefetch sibling product pages for color swatches to make color changes faster on product pages.

// Prefetch siblings only for main color swatches section. Do not remove.
window.addEventListener('load', function () {
  if (!document.body.classList.contains('template-product')) return;

  const swatches = document.querySelectorAll(
    'a.main-swatch-color-product[href]'
  );

  const head = document.head;
  const added = new Set();
  const currentPath = window.location.pathname.replace(/\/$/, '');

  swatches.forEach(function (swatch) {
    let url = swatch.getAttribute('href');
    if (!url) return;

    if (!url.startsWith('http')) {
      url = new URL(url, window.location.origin).href;
    }

    const path = new URL(url).pathname.replace(/\/$/, '');

    if (path === currentPath || added.has(path)) return;
    added.add(path);

    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = url;
    head.appendChild(link);
  });
});